'use client'

/**
 * Desk chassis — one Ant size + token face for every instrument control.
 * Wrap a bay (DeskShell, rail, ticket) so Select / Button / Switch / Segmented
 * share the same small rack, not a mix of 44px SaaS pills and native HTML.
 */

import React, { type ReactNode } from 'react'
import { ConfigProvider } from 'antd'
import type { SizeType } from 'antd/es/config-provider/SizeContext'
import styles from './DeskChassis.module.css'

export const DESK_EMPTY = '—'
export const DESK_CONTROL_SIZE: SizeType = 'small'

export interface DeskChassisProps {
  children: ReactNode
  size?: SizeType
}

export function DeskChassis({ children, size = DESK_CONTROL_SIZE }: DeskChassisProps) {
  return (
    <ConfigProvider componentSize={size}>
      <div className={styles.chassis} data-desk-chassis="">
        {children}
      </div>
    </ConfigProvider>
  )
}
